import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { capitalizeFirstLetter } from '../pages/attendee/detail/components/utils';

export default class ModerationTransitionConditions extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId, transitionId }) {
        if (!transitionId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transition_conditions`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transitions/${transitionId}/transition_conditions`;
    }

    toOption() {
        return {
            key: this.id,
            value: this.id,
            text: this.type,
            name: this.type,
            item: this.object
        };
    }

    get status_color() {
        return this.object.active ? 'green' : 'gray';
    }

    get name() {
        return capitalizeFirstLetter(this.object.name);
    }

    get status() {
        return this.object.active ? 'active' : 'inactive';
    }

    activate({ organizationId, flowId }) {
        let url = `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transition_conditions/${this.pk}/activate`;

        return fetcher.post(url);
    }

    deactivate({ organizationId, flowId }) {
        let url = `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transition_conditions/${this.pk}/deactivate`;

        return fetcher.post(url);
    }
}
